import { render, staticRenderFns } from "./RewardPrizePool.vue?vue&type=template&id=74078a90&"
import script from "./RewardPrizePool.vue?vue&type=script&lang=js&"
export * from "./RewardPrizePool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports